import { MatchOfferDeclineReason } from "../enums";

export interface IMatchOfferDeclineChoices {
    isDonorAcceptable: boolean,
    isSurgeryDateAcceptable: boolean,
    deactivatePatient: boolean,
    declineReasons: { id: number, otherText: string, nextAvailText: string }[]
}